export default __webpack_public_path__ + "static/media/img-book.ec7edf86.svg";